

















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { GridOptions } from '@/types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DELETE_PRODUCT_NOTE,
  FETCH_PRODUCT_NOTES, FETCH_PRODUCT_NOTES_METADATA,
} from '@/store/action-types'
import moment from 'moment'
import PrivateCellRenderer from '@/components/cell-renderer/PrivateCellRenderer.vue'
import {
  ProductNotesMetaDataResponse,
  ProductNotesResponse, ResponseBase
} from '@/types/service-response'
import ProductNotesDialog from '@/components/master-data/product/ProductNotesDialog.vue'
import { ProductNote } from '@/model/products/ProductNote'
import { ProductNoteType } from '@/model/products/ProductNoteType'
import { ProductNoteEmployee } from '@/model/products/ProductNoteEmployee'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  employeeList: ProductNoteEmployee[]
  noteTypeList: ProductNoteType[]

  gridData: ProductNote[]
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  currentSelectedRowId: string
  currentSelectedRowData: ProductNote | undefined
  showDialog: boolean
  showDeleteDialog: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProductNotes',

  components: {
    AgGridVue,
    DeleteDialog,
    ProductNotesDialog
  },

  props: {
    productId: Number,
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      employeeList: [],
      noteTypeList: [],

      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.addresses.title'), field: 'noteTitle' },
          { headerName: this.$t('masterData.addresses.responsibleName'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const employee: ProductNoteEmployee | undefined = this.employeeList.find((item: ProductNoteEmployee) => item.id === params.data.responsibleEmployee)
              return employee ? employee.fullName : ''
            }
          },
          { headerName: this.$t('masterData.addresses.noticeTypeDescription'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const noteType: ProductNoteType | undefined = this.noteTypeList.find((item: ProductNoteType) => item.id === params.data.noteType)
              return noteType ? noteType.name : ''
            }
          },
          { headerName: this.$t('masterData.addresses.start'),
            valueGetter: (params: any) => {
              return params.data.dateStartIso ? moment(params.data.dateStartIso, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY") : ''
            }
          },
          { headerName: this.$t('masterData.addresses.due'),
            valueGetter: (params: any) => {
              return params.data.dateEndIso ? moment(params.data.dateEndIso, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY") : ''
            }
          },
          { headerName: this.$t('masterData.addresses.completed'), field: 'alreadyDone' },
          { headerName: this.$t('masterData.addresses.private'), field: 'isPrivate', cellRenderer: 'privateRenderer'},
          { headerName: this.$t('masterData.addresses.description'), field: 'noteText' }
        ]
      },
      gridFrameworkComponents: {
        privateRenderer: PrivateCellRenderer
      },
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      currentSelectedRowId: '',
      currentSelectedRowData: undefined,
      showDialog: false,
      showDeleteDialog: false,

      keyActions: []
    }
  },

  watch: {
    productId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.currentSelectedRowId = ''
        this.currentSelectedRowData = undefined
        this.fetchNoteMetadata()
        this.fetchNotesData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableButtons (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableButtons
      } else if(action instanceof Delete) {
        return this.isEnableButtons
      } else {
        return false
      }
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: ProductNote) => item.id === parseInt(this.currentSelectedRowId))
    },

    onAddNoteClick ():void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.currentSelectedRowData = undefined
      this.showDialog = true
    },

    onEditNoteButtonClick ():void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.showDialog = true
    },

    dialogSaved (): void {
      this.fetchNotesData()
      this.currentSelectedRowData = undefined
      this.showDialog = false
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteNoteButtonClick ():void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
        if(this.currentSelectedRowData && this.currentSelectedRowData.id) {
          this.deleteNote(this.currentSelectedRowData.id)
        }
    },

    async deleteNote (payload: number): Promise<void> {
      try {
        let response: ResponseBase = await this.$store.dispatch(DELETE_PRODUCT_NOTE, payload)
        if(!response.IsError) {
          this.onDeleteDialogClose()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchNotesData()
        } else {
          this.onDeleteDialogClose()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchNotesData (): Promise<void> {
      try {
        const response: ProductNotesResponse = await this.$store.dispatch(FETCH_PRODUCT_NOTES, this.productId)
        if(response && !response.IsError && response.Data) {
          this.gridData = ProductNote.createFromResponse(response.Data)
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchNoteMetadata (): Promise<void> {
      try {
      const response: ProductNotesMetaDataResponse = await this.$store.dispatch(FETCH_PRODUCT_NOTES_METADATA)
        if(response && !response.IsError && response.Data) {
          this.employeeList = ProductNoteEmployee.createFromResponse(response.Data.Mitarbeiter)
          this.noteTypeList = ProductNoteType.createFromResponse(response.Data.NotizArten)
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.fetchNoteMetadata()
    this.fetchNotesData()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
